export default {"src":"/_next/static/media/icone-aura.1b814c3d.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};